import { MutationTree } from 'vuex';
import { AuthState, Company } from './types';
import amplitude from 'amplitude-js/amplitude';
import { GDSStationFactory } from '../../shared/factory/station-factory/gdsStations-factory';

export const mutations: MutationTree<AuthState> = {
    login (state, payload: string) {
        state.loggedIn = true;
        state.accessToken = payload;
    },
    logout (state) {
        state.accessToken = null;
        state.loggedIn = false;
        state.username = null;
        state.email = null;
        state.activeCompany = null;
    },
    updateToken (state, payload) {
        state.email = payload.user_name;
        state.username = payload.name;
        state.authorities = payload.authorities;
        state.group = payload.group;
        state.isB2B = payload.isB2B;
    },
    switchWorkspace (state, key: string) {
        let workspace = undefined;

        if (state && state.authorities && state.authorities[0].companies && state.authorities[0].companies.find(i => i === key || i === '*'))
            workspace = state.authorities[0];

        if (state.companies.length > 0) {
            const companyName = state.companies.find(company => company.companyKey === key).name;
            state.activeCompany = { company: key, roles: workspace.roles, name: companyName };
        } else {
            state.activeCompany = { company: key, roles: workspace.roles, name: '' };
        }
        const gdsStations = new GDSStationFactory();
        (async () => {
            const stations = await gdsStations.getStationsForCompany();
            localStorage.setItem('companiesStations', JSON.stringify(stations));
        })();
    },
    updateCompanies(state, companies: Array<Company>) {
        state.companies = companies;
    },
    initAmplitude (state) {
        amplitude.init(window.CONFIG.AMPLITUDE_API_KEY, state.email, {
            'saveEvents': true,
            'batchEvents': true,
            'includeReferrer': true
        });
        const userProperties = {
            'company': state.activeCompany.company,
            'roles': state.activeCompany.roles,
        };
        amplitude.getInstance().setUserProperties(userProperties);
    }
};
